/*
Akhila 11/19/2022 2700271704 Created new Component
Prakash 11/22/2022 2700271704 Removed Margin spacing.
*/
import React from 'react';
import TriggerAccountSearchForm from './TriggerAccountSearchForm';
function SearchAccountTrigger({setValue}) {
  // reset Trigger Group Data(2700423152)
  // useEffect(() => {
  //   dispatch(resetTriggerGroupData());
  // }, []);

  return (
    <>
      <TriggerAccountSearchForm setValue={setValue} />
    </>
  );
}

export default SearchAccountTrigger;
